export const theme = {
  fontFamily: 'Lato-Semibold',
  fontSize: 12,
  axis: {
    domain: {
      line: {
        stroke: 'transparent',
        strokeWidth: 1,
      },
    },
    ticks: {
      line: {
        stroke: '#f1f3f7',
        strokeWidth: 2,
      },
      text: {
        fill: '#979fb1',
      },
    },
    textColor: 'red',
    fontSize: '14px',
    tickColor: '#f1f3f7',
  },
  grid: {
    line: {
      stroke: '#f1f3f7',
      strokeWidth: 2,
    },
  },
  crosshair: {
    line: {
      stroke: '#f1f3f7',
      strokeWidth: 2,
      strokeOpacity: 1,
      strokeDasharray: '',
    },
  },
  tooltip: {
    container: {
      background: 'white',
      color: 'inherit',
      fontSize: 'inherit',
      borderRadius: '5px',
      boxShadow: '0px 12px 27px 0 rgba(211, 225, 239, 0.5)',
      padding: '5px 9px',
    },
  },
};
